<template>
  <!-- eslint-disable vue/first-attribute-linebreak, vue/max-attributes-per-line -->
  <div class="terms-policy">
    <div class="terms-policy__header">
      <div class="terms-policy__title">Пользовательское соглашение</div>
      <div class="terms-policy__date">
        Дата публикации: <time class="terms-policy__date-value">01.09.2026</time>
      </div>
    </div>
    <ul class="terms-policy__list">
      <li class="terms-policy__item">
        <div class="terms-policy__item-title">1. Общие положения</div>
        <div class="terms-policy__item-text">
          <p class="terms-policy__item-paragraph">
            1.1. Настоящее Пользовательское соглашение (далее — Соглашение) является
            публичной офертой Общества с ограниченной ответственностью «ЛИГАЛ АДС ТЕХ»
            (ОГРН 1227700103245, ИНН 9709078420, далее — Компания) в соответствии с
            пунктом 2 статьи 437 Гражданского кодекса Российской Федерации и определяет
            условия использования сервиса «Юрик.ру».
          </p>
          <p class="terms-policy__item-paragraph">
            1.2. Полным и безоговорочным акцептом Соглашения является начало использования
            Сервиса, регистрация на Сервисе либо оформление Обращения любым способом,
            предусмотренным Соглашением, включая телефонное обращение к Компании.
          </p>
          <p class="terms-policy__item-paragraph">
            1.3. Соглашение, заключенное указанным способом, считается совершённым в
            простой письменной форме и не требует оформления на бумажном носителе.
          </p>
          <p class="terms-policy__item-paragraph">
            1.4. Компания вправе изменять условия Соглашения в одностороннем порядке,
            публикуя новую редакцию на Сервисе не менее чем за 3 (три) календарных дня до
            вступления изменений в силу. Продолжение использования Сервиса после
            вступления изменений в силу означает согласие Пользователя с новой редакцией.
          </p>
          <p class="terms-policy__item-paragraph">
            1.5. Финансовые условия использования Сервиса Специалистами регулируются
            отдельным документом — Офертой для Специалистов, размещенной в разделе
            «Правовые документы» Сервиса.
          </p>
        </div>
      </li>
      <li class="terms-policy__item">
        <div class="terms-policy__item-title">2. Термины и определения</div>
        <div class="terms-policy__item-text">
          <p class="terms-policy__item-paragraph">
            2.1. «Сервис», «Сайт» — онлайн-платформа «Юрик.ру» (программа для ЭВМ и база
            данных), расположенная по адресу
            <a
              class="terms-policy__item-link"
              href="https://jurik.ru"
              target="_blank"
              rel="noopener noreferrer"
              >https://jurik.ru</a
            >, позволяющая Заказчикам осуществлять поиск и выбор Специалистов,
            записываться на консультации и обращаться за юридической помощью, а
            Специалистам — размещать Профиль и получать обращения Заказчиков.
          </p>
          <p class="terms-policy__item-paragraph">
            2.2. «Пользователь» — дееспособное физическое лицо, достигшее 18 лет, либо
            юридическое лицо, использующее Сервис. Термин охватывает Заказчиков и
            Специалистов, а также лиц, не прошедших регистрацию.
          </p>
          <p class="terms-policy__item-paragraph">
            2.3. «Заказчик» — Пользователь, обращающийся через Сервис или к Компании за
            поиском Специалиста, записью на консультацию или иной юридической помощью.
          </p>
          <p class="terms-policy__item-paragraph">
            2.4. «Специалист» — Пользователь (Юрист, Адвокат, Адвокатский кабинет,
            Юридическая компания, Адвокатское образование), разместивший Профиль для
            оказания юридических услуг Заказчикам. Категории Специалистов и требования к
            их верификации определены разделом 6 Соглашения.
          </p>
          <p class="terms-policy__item-paragraph">
            2.5. «Партнёр Компании» — юрист или юридическая компания, привлекаемые
            Компанией для оказания юридической помощи Заказчикам на основании договора с
            Компанией, содержащего условия о конфиденциальности.
          </p>
          <p class="terms-policy__item-paragraph">
            2.6. «Профиль» («Карточка Специалиста») — общедоступная страница Специалиста
            на Сервисе, содержащая сведения о нём, его специализациях, опыте, ценах на
            услуги, расписании приёма и отзывы Заказчиков.
          </p>
          <p class="terms-policy__item-paragraph">
            2.7. «Обращение» — любое обращение Заказчика за юридической помощью,
            поступившее Компании или через Сервис: Запись, Вопрос, заявка на подбор
            Специалиста, заявка на услугу, телефонное обращение, а также обращение,
            поступившее через информационные ресурсы партнеров Компании.
          </p>
          <p class="terms-policy__item-paragraph">
            2.8. «Запись» — бронирование консультации у Специалиста на выбранные дату и
            время (слот) в выбранном формате (приём в офисе Специалиста либо дистанционная
            (онлайн) консультация), оформленное Заказчиком самостоятельно через Сервис
            либо оператором Компании на основании Обращения Заказчика, поступившего любым
            способом.
          </p>
          <p class="terms-policy__item-paragraph">
            2.9. «Подтверждение Записи» — действие Специалиста в Личном кабинете, которым
            он принимает Запись и обязуется провести консультацию, либо приравненные к
            нему события, предусмотренные Соглашением и Офертой для Специалистов.
          </p>
          <p class="terms-policy__item-paragraph">
            2.10. «Вопрос» — обращение Заказчика к Специалисту через форму Сервиса с
            выбором способа получения ответа (чат Сервиса, телефонный звонок,
            мессенджеры).
          </p>
          <p class="terms-policy__item-paragraph">
            2.11. «Личный кабинет» — персональный раздел Пользователя на Сервисе, доступ к
            которому предоставляется после регистрации.
          </p>
          <p class="terms-policy__item-paragraph">
            2.12. «Лицевой счет» — виртуальный счет Специалиста на Сервисе; порядок его
            ведения определен Офертой для Специалистов.
          </p>
          <p class="terms-policy__item-paragraph">
            2.13. Термины, не определенные Соглашением, толкуются в соответствии с
            законодательством Российской Федерации, а при отсутствии нормативного
            определения — в соответствии со сложившейся практикой использования в сети
            Интернет.
          </p>
        </div>
      </li>
      <li class="terms-policy__item">
        <div class="terms-policy__item-title">3. Предмет Соглашения</div>
        <div class="terms-policy__item-text">
          <p class="terms-policy__item-paragraph">
            3.1. Компания предоставляет Пользователю право использования Сервиса (простая
            неисключительная лицензия) в пределах его функциональных возможностей:
            Заказчикам — поиск и выбор Специалистов, оформление Записей, направление
            Вопросов и иных Обращений; Специалистам — размещение Профиля, ведение
            расписания, получение и обработка Записей и Вопросов.
          </p>
          <p class="terms-policy__item-paragraph">
            3.2. Юридические услуги Заказчику оказывает непосредственно Специалист или
            Партнёр Компании. Компания не оказывает юридических услуг, не является
            стороной отношений между Заказчиком и исполнителем, не выступает работодателем
            Специалистов и не отвечает за результат оказанных ими услуг.
          </p>
          <p class="terms-policy__item-paragraph">
            3.3. Заказчик и исполнитель самостоятельно согласовывают условия оказания
            юридических услуг, включая их стоимость. Сведения о ценах и условиях
            консультаций Специалиста указываются в его Профиле.
          </p>
          <p class="terms-policy__item-paragraph">
            3.4. Если Обращение Заказчика не адресовано конкретному Специалисту (заявка на
            подбор, телефонное обращение), Компания подбирает исполнителя из числа
            Специалистов, размещенных на Сервисе, и Партнёров Компании. Исполнитель
            связывается с Заказчиком преимущественно по указанному Заказчиком номеру
            телефона либо иным способом, указанным Заказчиком в Обращении.
          </p>
          <p class="terms-policy__item-paragraph">
            3.5. Компания вправе отказать Пользователю в доступе к Сервису при нарушении
            им условий Соглашения.
          </p>
        </div>
      </li>
      <li class="terms-policy__item">
        <div class="terms-policy__item-title">4. Записи на консультацию</div>
        <div class="terms-policy__item-text">
          <p class="terms-policy__item-paragraph">
            4.1. Заказчик оформляет Запись, выбирая Специалиста, дату, время и формат
            консультации. При самостоятельном оформлении через Сервис Заказчик
            подтверждает номер телефона кодом из СМС; при оформлении Записи оператором
            Компании номер телефона Заказчика считается подтвержденным в ходе телефонного
            разговора с оператором.
          </p>
          <p class="terms-policy__item-paragraph">
            4.2. После оформления Запись ожидает Подтверждения Специалистом. Срок ожидания
            подтверждения зависит от времени, оставшегося до консультации, и отображается
            Заказчику. Если Специалист не подтвердил Запись в отведенный срок, Запись
            отменяется, о чем Заказчик уведомляется.
          </p>
          <p class="terms-policy__item-paragraph">
            4.3. Заказчик вправе отменить Запись в любой момент до начала консультации, а
            после Подтверждения — однократно перенести ее на другое доступное время.
          </p>
          <p class="terms-policy__item-paragraph">
            4.4. Уведомления о статусе Записи (принята, подтверждена, отменена,
            перенесена, напоминания) направляются Заказчику и Специалисту по указанным ими
            контактам (СМС, электронная почта, уведомления Сервиса).
          </p>
          <p class="terms-policy__item-paragraph">
            4.5. Компания вправе связаться с Заказчиком по указанному им номеру телефона
            для уточнения или подтверждения деталей Обращения. Телефонные разговоры могут
            записываться в целях контроля качества, о чём сторона разговора уведомляется в
            установленном законом порядке.
          </p>
        </div>
      </li>
      <li class="terms-policy__item">
        <div class="terms-policy__item-title">5. Регистрация</div>
        <div class="terms-policy__item-text">
          <p class="terms-policy__item-paragraph">
            5.1. Для доступа к отдельным функциям Сервиса Пользователь проходит
            регистрацию, предоставляя достоверные и актуальные данные, и несет
            ответственность за их достоверность.
          </p>
          <p class="terms-policy__item-paragraph">
            5.2. Пользователь обязан сохранять конфиденциальность данных доступа к Личному
            кабинету и незамедлительно уведомлять Компанию об их компрометации. Действия,
            совершённые в Личном кабинете Пользователя, считаются совершенными
            Пользователем.
          </p>
        </div>
      </li>
      <li class="terms-policy__item">
        <div class="terms-policy__item-title">6. Верификация Специалистов</div>
        <div class="terms-policy__item-text">
          <p class="terms-policy__item-paragraph">
            6.1. Размещение Профиля возможно только после верификации Специалиста. Для
            верификации предоставляются: для Юриста — фамилия, имя, отчество, адрес
            электронной почты, контактный телефон, сведения об образовании (диплом), стаж,
            ИНН, специализации; для Адвоката — дополнительно реестровый номер адвоката;
            для Юридической компании и Адвокатского образования — фирменное наименование,
            реквизиты юридического лица (ИНН, ОГРН, КПП), адреса, сведения о руководителе;
            иные документы по запросу Компании, необходимые для подтверждения статуса.
          </p>
          <p class="terms-policy__item-paragraph">
            6.2. Компания вправе проверять предоставленные сведения, запрашивать
            подтверждающие документы, приглашать Специалиста на собеседование, а также
            отказать в верификации или отозвать её. Отзыв верификации возможен, в
            частности, при предоставлении недостоверных сведений, систематических
            нарушениях договоренностей с Заказчиками, получении обоснованных жалоб,
            нарушении правил общения на Сервисе.
          </p>
          <p class="terms-policy__item-paragraph">
            6.3. Публикуя Профиль, Специалист делает содержащиеся в нём сведения
            общедоступными на условиях отдельного согласия на распространение персональных
            данных.
          </p>
        </div>
      </li>
      <li class="terms-policy__item">
        <div class="terms-policy__item-title">7. Права и обязанности Пользователей</div>
        <div class="terms-policy__item-text">
          <p class="terms-policy__item-paragraph">
            7.1. Пользователь обязан: предоставлять достоверные сведения; не использовать
            Сервис для размещения незаконной, оскорбительной или рекламной информации; не
            совершать действий, направленных на обход Сервиса при взаимодействии Заказчика
            и Специалиста, найденных друг другом через Сервис; не нарушать права третьих
            лиц и законодательство Российской Федерации.
          </p>
          <p class="terms-policy__item-paragraph">
            7.2. Специалист обязан: лично оказывать услуги (для Юристов и Адвокатов) либо
            силами своей организации (для компаний и образований); использовать контактные
            данные Заказчиков исключительно для исполнения их обращений и не передавать их
            третьим лицам; поддерживать актуальность Профиля и расписания; своевременно
            обрабатывать Записи и Вопросы; быть корректным в общении.
          </p>
          <p class="terms-policy__item-paragraph">
            7.3. Заказчик вправе оставить отзыв о Специалисте после состоявшейся
            консультации. Отзывы проходят модерацию. Специалист вправе оспорить отзыв,
            обратившись в поддержку Компании с обоснованием; Компания рассматривает
            обращение и вправе скрыть отзыв, нарушающий требования Соглашения.
          </p>
        </div>
      </li>
      <li class="terms-policy__item">
        <div class="terms-policy__item-title">8. Интеллектуальная собственность</div>
        <div class="terms-policy__item-text">
          <p class="terms-policy__item-paragraph">
            8.1. Исключительные права на Сервис принадлежат Компании. Пользователю
            предоставляется право использовать Сервис по функциональному назначению в
            рамках Соглашения; любое иное использование, включая копирование базы данных
            Сервиса, запрещено.
          </p>
          <p class="terms-policy__item-paragraph">
            8.2. Материалы Профиля предоставлены Специалистом; ответственность за их
            достоверность и правомерность несёт Специалист. Специалист предоставляет
            Компании безвозмездную простую неисключительную лицензию без ограничения срока
            и территории на использование материалов Профиля для работы и продвижения
            Сервиса и услуг Специалиста, включая размещение в рекламных материалах Сервиса
            и его партнёров, в средствах массовой информации, социальных сетях и иных
            информационных ресурсах.
          </p>
          <p class="terms-policy__item-paragraph">
            8.3. Статьи и иные материалы, опубликованные Специалистом в журнале (блоге)
            Сервиса, предоставляются Компании на безвозмездной основе: Специалист
            предоставляет Компании безвозмездную простую неисключительную лицензию на их
            использование любыми способами без ограничения срока и территории. Такие
            материалы остаются на Сервисе и могут использоваться Компанией, в том числе
            после удаления Профиля Специалиста или прекращения отношений с ним; за
            Специалистом сохраняется право авторства.
          </p>
        </div>
      </li>
      <li class="terms-policy__item">
        <div class="terms-policy__item-title">9. Ответственность</div>
        <div class="terms-policy__item-text">
          <p class="terms-policy__item-paragraph">
            9.1. Компания не отвечает за результат юридических услуг Специалиста или
            Партнёра Компании, соответствие результата ожиданиям Заказчика, а также за
            достоверность сведений, сообщенных Пользователями.
          </p>
          <p class="terms-policy__item-paragraph">
            9.2. Компания не гарантирует бесперебойную работу Сервиса, однако принимает
            разумные меры для ее обеспечения.
          </p>
          <p class="terms-policy__item-paragraph">
            9.3. Пользователь несет ответственность за нарушение условий Соглашения в
            соответствии с законодательством Российской Федерации.
          </p>
        </div>
      </li>
      <li class="terms-policy__item">
        <div class="terms-policy__item-title">10. Обстоятельства непреодолимой силы</div>
        <div class="terms-policy__item-text">
          <p class="terms-policy__item-paragraph">
            10.1. Стороны освобождаются от ответственности за неисполнение обязательств,
            вызванное обстоятельствами непреодолимой силы (стихийные бедствия, военные
            действия, массовые беспорядки, акты органов власти, сбои сетей связи и
            энергоснабжения, вредоносные действия третьих лиц), при условии уведомления
            другой стороны в разумный срок.
          </p>
        </div>
      </li>
      <li class="terms-policy__item">
        <div class="terms-policy__item-title">11. Заключительные положения</div>
        <div class="terms-policy__item-text">
          <p class="terms-policy__item-paragraph">
            11.1. Вопросы, не урегулированные Соглашением, регулируются законодательством
            Российской Федерации.
          </p>
          <p class="terms-policy__item-paragraph">
            11.2. Претензионный порядок обязателен: претензии направляются на адрес
            электронной почты
            <a class="terms-policy__item-link" href="mailto:info@jurik.ru"
              >info@jurik.ru</a
            >
            либо по юридическому адресу Компании; срок ответа — 14 (четырнадцать)
            календарных дней с даты получения.
          </p>
          <p class="terms-policy__item-paragraph">
            11.3. Споры с участием Заказчиков — потребителей рассматриваются в
            соответствии с правилами подсудности, установленными законодательством о
            защите прав потребителей. Иные споры рассматриваются в суде общей юрисдикции
            по месту нахождения Компании, а споры, подведомственные арбитражному суду, — в
            Арбитражном суде города Москвы.
          </p>
          <p class="terms-policy__item-paragraph">
            11.4. Соглашение вступает в силу с момента акцепта и действует до его
            расторжения в установленном порядке.
          </p>
          <p class="terms-policy__item-paragraph">
            11.5. Контакты Компании: ООО «ЛИГАЛ АДС ТЕХ», ОГРН 1227700103245, ИНН
            9709078420, e-mail:
            <a class="terms-policy__item-link" href="mailto:info@jurik.ru"
              >info@jurik.ru</a
            >.
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>

<style lang="less">
.terms-policy {
  .flex-column(@size-x10);

  &__header {
    .flex-column(@size-x3);
  }

  &__title {
    .h-offset-reset();

    font-size: @size-x8;
    font-weight: 700;
    line-height: 130%;
  }

  &__date {
    font-size: @size-x4;
    font-weight: 400;
    line-height: 130%;
    color: @color-dove-gray;
  }

  &__list {
    .flex-column(@size-x10);

    max-width: 997px;
  }

  &__item {
    .flex-column(@size-x6);
  }

  &__item-title {
    .h-offset-reset();

    font-size: @size-x6;
    font-weight: 700;
    line-height: 130%;
  }

  &__item-text {
    .flex-column(@size-x4);
  }

  &__item-paragraph {
    .p-offset-reset();

    font-size: @size-x4;
    font-weight: 400;
    line-height: 130%;
  }

  &__item-link {
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
}
</style>
